export default __webpack_public_path__ + "static/media/bet.a550a587.mp3";